// src/components/LanguageSelector.jsx
import React, { useMemo } from "react";
import Select from "react-select";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

// ✅ Language list with flag + label
const languages = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "bn", label: "বাংলা", flag: "🇧🇩" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "ur", label: "اردو", flag: "🇵🇰" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "id", label: "Bahasa Indonesia", flag: "🇮🇩" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ms", label: "Bahasa Melayu", flag: "🇲🇾" },
  { code: "th", label: "ภาษาไทย", flag: "🇹🇭" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "fa", label: "فارسی", flag: "🇮🇷" },
  { code: "sw", label: "Kiswahili", flag: "🇰🇪" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
];

// ✅ Build options for react-select
const options = languages.map((lang) => ({
  value: lang.code,
  label: `${lang.flag} ${lang.label}`,
}));

const LanguageSelector = () => {
  const { t } = useTranslation();

  // ✅ MVP: lock to English display, keep UI (incl. arrow), but block opening/changing
  const lockedValue = useMemo(() => options.find((opt) => opt.value === "en") || options[0], []);

  const handleChange = () => {
    // ✅ intentionally no-op for MVP (do not change language)
    return;
  };

  return (
    <div style={{ minWidth: "180px", marginLeft: "auto" }}>
      <Select
        options={options}
        value={lockedValue}
        onChange={handleChange}
        isSearchable={false}
        menuPlacement="top" // ✅ Forces the dropdown to open upward

        // ✅ key part: keep the control looking normal, but never open the menu
        menuIsOpen={false}
        openMenuOnClick={false}
        openMenuOnFocus={false}

        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: "#fff",
            color: "#000",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            maxHeight: "400px",
            overflowY: "auto",
            backgroundColor: "#fff",
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#2684FF" : state.isFocused ? "#f0f0f0" : "#fff",
            color: "#000",
            cursor: "pointer",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#000",
          }),
        }}
      />
    </div>
  );
};

export default LanguageSelector;
